<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="content-chapter1" id="calibre_toc_5"><a href="#/OEBPS/5Ingredient_split_006#_idTextAnchor020">Baking Pantry Essentials<span id="_idTextAnchor003"></span> </a></p>
<p class="body_body">Dessi is the baker in the family, and I wanted to make sure she shared a bunch of her sweet recipes in this book. For the most part, Dessi’s recipes are paleo, and always gluten-free. Here are the pantry essentials you will need to stock up on to make her yummy desser<span>t</span><span> </span><span>recipes.</span></p>
<p class="body_heading">100% Grass-Fed Ghee</p>
<p class="shopping-tip-over-images">Ghee is like butter, but even better! Make sure it’s 100% grass-fed. I don’t want any GMOs in your kitchen!</p>
<p class="body_heading">Butter</p>
<p class="shopping-tip-over-images">When it comes to butter, go for unsalted Kerrygold.</p>
<p class="body_heading">Baking Soda</p>
<p class="shopping-tip-over-images">Nothing fancy here. Any type will do.</p>
<p class="body_heading"><span class="shopping-tip-blue">Pure Vanilla Extract</span></p>
<p class="shopping-tip-over-images">No imitation vanilla. The real deal!</p>
<p class="body_heading"><span class="shopping-tip-blue">Virgin Coconut Oil</span></p>
<p class="shopping-tip-over-images">Virgin coconut oil is a one-to-one replacement for any fat in sweet or savory recipes. Stick with unprocessed virgin oil.</p>
<p class="body_heading"><span class="shopping-tip-blue">Salt</span></p>
<p class="shopping-tip-over-images">Celtic Sea Salt® or Himalayan pink salt.</p>
<div class="calibre1" id="calibre_pb_42"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_024.vue?065fee78